import(/* webpackMode: "eager" */ "/var/www/truligo.com/proxio-fe/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/var/www/truligo.com/proxio-fe/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/var/www/truligo.com/proxio-fe/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/var/www/truligo.com/proxio-fe/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["LoggerProvider"] */ "/var/www/truligo.com/proxio-fe/src/page-components/LoggerContext/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/truligo.com/proxio-fe/src/page-components/Search/SearchHeader/SearchHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/truligo.com/proxio-fe/src/page-components/Vendor/FooterVendor/FooterVendor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/truligo.com/proxio-fe/src/page-components/Vendor/HeadSection/HeadSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/truligo.com/proxio-fe/src/page-components/Vendor/MainSection/MainSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/truligo.com/proxio-fe/src/page-components/Vendor/ReportSection/ReportSection.tsx");
